<template>
  <div class="ti-confirmation-section">
    <UsabillaComponent
      class="usabilla-component"
      :usabillaConfig="
        applicationInfos.usabilla.configurationId[configurationId]
      "
    />

    <div class="ti-benefits-wrapper">
      <HeaderComponent :headline="$t('i18n.whatsNext.headline')" />
      <WhatsNextComponent />
    </div>

    <div class="ti-nba-wrapper" v-if="nbas && nbas.length > 1">
      <HeaderComponent :headline="$t('i18n.nextBestActivity.headline')" />
      <div class="ti-nba-wrapper__item" v-for="item in nbas" :key="item.id">
        <NextBestAction
          :url="item.url"
          :targetBlank="item.targetBlank"
          :description="$t(item.description)"
          :label="$t(item.label)"
          :image="$parseSrc($t(item.image))"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import setup from '../../composables/setup';

import HeaderComponent from '../../components/header/header.vue';
import NextBestAction from '../../components/next-best-action/next-best-action.vue';
import WhatsNextComponent from '../../components/whatsnext/whatsnext.vue';
import UsabillaComponent from '../../components/usabilla/usabilla.vue';

import { NextBestActionItem } from '@tradein/api';

interface Props {
  nbas?: Array<NextBestActionItem>;
}

const { $parseSrc, applicationInfos, configurationId } = setup();
const props = defineProps<Props>();
</script>

<style lang="scss" src="./confirmation-section.scss"></style>
